export const uxDesignerEssentialTools = {
  primary: {
    junior: ['Figma', 'Adobe XD', 'Sketch (macOS)', 'Miro', 'Notion'],
    mid: ['Figma', 'Adobe Creative Suite', 'Sketch', 'Principle', 'Framer', 'Miro', 'Notion'],
    senior: ['Figma', 'Adobe Creative Suite', 'Sketch', 'Principle', 'Framer', 'Miro', 'Notion', 'Abstract']
  },
  secondary: {
    junior: ['Loom', 'Zoom', 'Slack', 'Google Drive'],
    mid: ['Loom', 'UsabilityHub', 'Hotjar', 'Maze', 'Slack', 'Linear'],
    senior: ['Loom', 'UsabilityHub', 'Hotjar', 'Maze', 'Amplitude', 'Mixpanel', 'Linear', 'Confluence']
  },
  advanced: {
    junior: [],
    mid: ['After Effects', 'ProtoPie', 'Zeplin'],
    senior: ['After Effects', 'ProtoPie', 'Zeplin', 'Abstract', 'InVision DSM', 'Storybook']
  },
  commands: {
    macos: [
      {
        tool: 'Figma Desktop',
        command: '# Download from https://www.figma.com/downloads/',
        description: 'Primary design tool'
      },
      {
        tool: 'Sketch',
        command: 'brew install --cask sketch',
        description: 'macOS design tool'
      },
      {
        tool: 'Adobe Creative Cloud',
        command: '# Subscribe at https://www.adobe.com/creativecloud.html',
        description: 'Design suite'
      }
    ],
    windows: [
      {
        tool: 'Figma Desktop',
        command: '# Download from https://www.figma.com/downloads/',
        description: 'Primary design tool'
      },
      {
        tool: 'Adobe Creative Cloud',
        command: '# Download from https://www.adobe.com/creativecloud.html',
        description: 'Design suite'
      }
    ],
    linux: [
      {
        tool: 'Figma (Web)',
        command: '# Use web version at https://www.figma.com/',
        description: 'Primary design tool'
      },
      {
        tool: 'GIMP',
        command: 'sudo apt install gimp',
        description: 'Image editing'
      },
      {
        tool: 'Inkscape',
        command: 'sudo apt install inkscape',
        description: 'Vector graphics'
      }
    ]
  }
};
